type CustomComparisonTickProps = {
  x: number;
  y: number;
  payload: { value: string };
  size?: 'small' | 'medium' | 'large';
};

export const CustomComparisonTick = ({
  x,
  y,
  payload,
  size = 'medium',
}: CustomComparisonTickProps) => {
  const getMaxLength = () => {
    switch (size) {
      case 'small':
        return 32;
      case 'large':
        return 84;
      case 'medium':
      default:
        return 42;
    }
  };

  const getMaxWords = () => {
    switch (size) {
      case 'small':
        return 3;
      case 'large':
        return 6;
      case 'medium':
      default:
        return 4;
    }
  };

  const truncateText = (text: string, maxLength: number) =>
    text.length > maxLength ? text.slice(0, maxLength) + '…' : text;

  const truncated = truncateText(payload.value, getMaxLength());
  const words = truncated.split(' ');

  const groupWords = (words: string[], groupSize: number) => {
    const groups: string[][] = [];
    for (let i = 0; i < words.length; i += groupSize) {
      groups.push(words.slice(i, i + groupSize));
    }
    return groups;
  };

  const wordGroups = groupWords(words, getMaxWords());

  return (
    <text
      x={x}
      y={y}
      dy={0}
      textAnchor="end"
      fill="#79716B"
      fontSize={12}
      fontWeight={400}
      letterSpacing="-0.01em"
    >
      {wordGroups.map(group => {
        const contentKey = group.join(' ');
        return (
          <tspan key={contentKey} x={x} dy={contentKey === wordGroups[0].join(' ') ? 0 : 14}>
            {contentKey}
          </tspan>
        );
      })}
    </text>
  );
};
